import React from 'react'
import deepEqual from 'fast-deep-equal'
import { BidHistoryTooltip } from '../bid_history_tooltip'
import type { ExtraType } from '../../types/table'
import { axiosPatch } from '../../util/api'
import { Toasts } from '../toaster/Toast'
import { UpdateReportAdTypes } from '../../util/contstants'
import { InheritableBidField } from '../bids/InheritableBidField'
import { canClearInheritedBid } from '../bids/inheritedBidClearPolicy'

interface BidChangeProps {
    keyword: any
    extra: any
}

export class KeywordBidChange extends React.Component<BidChangeProps> {
    shouldComponentUpdate(nextProps: Readonly<BidChangeProps>): boolean {
        return (
            !deepEqual(nextProps.keyword, this.props.keyword) ||
            !deepEqual(nextProps.extra, this.props.extra)
        )
    }

    render() {
        const { keyword, extra } = this.props
        return (
            <BidHistoryTooltip
                id={keyword.keyword_id}
                type={UpdateReportAdTypes.Keywords}
                campaign_id={keyword.campaign_id}
                bid={keyword.bid}
                bidLimits={keyword.bid_limits}
                bid_strategy={keyword.bid_strategy}
                bid_adjustment_top_of_search={keyword.bid_adjustment_top_of_search}
                bid_adjustment_rest_of_search={keyword.bid_adjustment_rest_of_search}
                bid_adjustment_home_page={keyword.bid_adjustment_home_page}
                bid_adjustment_product_page={keyword.bid_adjustment_product_page}
                ad_group_default_bid={keyword.ad_group_default_bid}
            >
                <InheritableBidField
                    bid={keyword.bid}
                    adGroupDefaultBid={keyword.ad_group_default_bid}
                    allowClear={canClearInheritedBid(keyword.profile_id)}
                    onSave={(cents) => updateBid(keyword.keyword_id, cents, extra)}
                />
            </BidHistoryTooltip>
        )
    }
}

const updateBid = (id: number, bid: number | null, extra: ExtraType) =>
    axiosPatch(`keywords/${id}`, { bid })
        .then(() => {
            Toasts.success('Bid successfully updated.')
            extra.reload()
        })
        .catch((err) => {
            if (err.response?.status === 409) {
                const ids = Object.keys(err.response.data)

                Toasts.warning(
                    `${ids.length} items were out of sync. Please review the changes and retry.`,
                )
                extra.reload()
            }
            throw err
        })
